<template>
  <div class="navbar-background" data-cy="orders-overview-bar">
    <div class="total-ordered-items-bar">
      <div class="overview-cnt">
        <div class="order-filter-preview">
          <i18n-t :keypath="`viewOrders.overview.filter.${filterType}`" scope="global">
            <template v-slot:from>
              <b>{{ from }}</b>
            </template>
            <template v-slot:to>
              <b>{{ to }}</b>
            </template>
          </i18n-t>
        </div>
        <BackstageButton
          data-cy="overview-details-button-cnt"
          data-cy-button="overview-details-button"
          v-on:click="showDetails()">
          {{ $t('viewOrders.overview.details') }}
        </BackstageButton>
      </div>
      <div class="ordered-items-total">
        <div class="info-icon-cnt">
          <BackstageIcon class="info-icon" data-cy="info-icon" name="info" />
          <span class="tooltip" data-cy="tooltip">
            {{ $t('viewOrders.overview.total_items_tooltip') }}
          </span>
        </div>
        <div class="item-count-box" data-cy="item-count-box">
          {{ $t('viewOrders.overview.total_items') }}
          <span class="item-count">{{ totalItems }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import BackstageButton from '@/components/common/BackstageButton.vue';
import BackstageIcon from '@/components/common/BackstageIcon.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'order-overview',
  components: {
    BackstageButton,
    BackstageIcon,
  },
  props: {
    from: {
      type: String,
      default: undefined,
    },
    to: {
      type: String,
      default: undefined,
    },
    totalItems: {
      type: Number,
      default: undefined,
    },
    filterType: {
      type: String,
      default: undefined,
    },
    orderNumbers: {
      type: Array<string>,
      default: () => [],
    },
  },
  methods: {
    showDetails() {
      const key = (Math.random() + 1).toString(36).substring(7);

      this.$router.push({
        path: '/summary',
        query: {
          key,
          from: this.from,
          to: this.to,
          filterType: this.filterType,
        },
      });
      window.localStorage.setItem(`order-numbers-${key}`, JSON.stringify(this.orderNumbers));
    },
  },
});
</script>

<style lang="scss" scoped>
.navbar-background {
  @include navbar-background;
  top: unset;
  position: sticky;
  bottom: 0px;
  box-shadow:
    0px 0px 4px var(--shadow-color),
    0px 16px 32px var(--shadow-color);
}

.total-ordered-items-bar {
  @include main-max-with;

  padding: 20px 40px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin: auto;

  .overview-cnt {
    display: flex;
    align-items: baseline;
    gap: 16px;

    .order-filter-preview {
      font-size: 0.875rem;
    }
  }

  .ordered-items-total {
    display: flex;
    align-items: center;
    gap: 12px;
    .info-icon-cnt {
      position: relative;

      .info-icon {
        width: 42px;
        height: 42px;
        cursor: help;
      }

      .tooltip {
        position: absolute;
        bottom: 150%;
        left: 50%;
        transform: translateX(-50%);
        min-width: 15rem;
        z-index: 1;
        display: none;
        padding: 10px;
        box-shadow: 0 20px 40px -14px rgb(0 0 0 / 25%);
        background-color: var(--primary-bg-color);
        color: var(--primary-text-color);
        font-size: 0.875rem;
        font-style: normal;
      }

      &:hover .tooltip {
        display: block;
      }
    }

    .item-count-box {
      border-radius: 4px;
      padding: 16px 20px;
      font-weight: 400;
      background-color: var(--bg-remark-color);

      .item-count {
        font-weight: 700;
        font-size: 1rem;
        padding-left: 15px;
      }
    }
  }
}
</style>
